<div class="finder">

  <div class="finder-content">

    <div class="finder-header">
      <h2>Neues Dokument hinzufügen</h2>
    </div>

    <div class="finder-body">
      <finder-upload-progress [status]="status"></finder-upload-progress>

      <div class="clearfix"></div>

      @if (status === 1) {
        <finder-upload-category
          [categories]="category"
          [initialData]="categoriesData"
          (forwardEmitter)="onNextCategories($event)">
        </finder-upload-category>
      }

      @if (status === 2) {
        <finder-upload-additional
          [additionals]="additionals"
          (forwardEmitter)="onNextAdditional($event)"
          (reverseEmitter)="onReverse('category')">
        </finder-upload-additional>
      }

      @if (status === 3) {
        <finder-upload-file
          [data]="{categories: categoriesData, additionals: additionalsData}"
          (forwardEmitter)="onNextFinish($event.guid)"
          (reverseEmitter)="onReverse('additional')">
        </finder-upload-file>
      }

      @if (success) {
        <finder-upload-success
          [searchType]="searchType"
          [guid]="guidData"
          [id]="id"
          (resetEmitter)="onReverse('start')"
          (updateStatusEmitter)="onUpdateStatus()">
        </finder-upload-success>
      }

      <div style="clear: both;">&nbsp;</div>
    </div>

  </div>

</div>
